export function normalizePhone(phone: string): string {
    return phone.startsWith('+') ? phone : `+${phone}`;
}

export function cutPlus(phone: string): string {
    return phone.startsWith('+') ? phone.substring(1) : phone;
}
